import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { LogIn, LayoutDashboard, QrCode, Newspaper, CalendarDays, Tag, Bell, BarChart3, ArrowRight, Download } from "lucide-react";
import { GUIDE_MODULES } from "../data/content";

const ICONS = { LogIn, LayoutDashboard, QrCode, Newspaper, CalendarDays, Tag, Bell, BarChart3 };
const GUIDE_PDF = "/guida-tutorial-pushapp.pdf";

export const GuideHub = () => {
  return (
    <section id="guide" className="py-20 sm:py-28 bg-[#F9FAFB]" data-testid="guide-hub-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div className="max-w-2xl">
            <span className="text-sm font-bold uppercase tracking-[0.2em] text-brand">Guide</span>
            <h1 className="mt-3 font-heading text-3xl sm:text-4xl font-bold tracking-tight text-brand-deep">
              Tutorial per usare la tua app
            </h1>
            <p className="mt-4 font-body text-base sm:text-lg text-ink leading-relaxed">
              Scegli l'argomento e apri la guida dedicata: spieghiamo ogni funzione passo-passo,
              con consigli pratici per ottenere il massimo.
            </p>
          </div>
          <a
            href={GUIDE_PDF}
            download
            target="_blank"
            rel="noreferrer"
            data-testid="guide-download-button"
            className="inline-flex flex-none items-center justify-center gap-2 rounded-full bg-brand px-6 py-3.5 font-body font-semibold text-white shadow-lg shadow-brand/25 transition-all duration-300 hover:bg-brand-hover hover:-translate-y-0.5"
          >
            <Download size={18} strokeWidth={2.5} /> Scarica guida tutorial
          </a>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {GUIDE_MODULES.map((m, i) => {
            const Icon = ICONS[m.icon];
            return (
              <motion.div
                key={m.slug}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.45, delay: (i % 3) * 0.08 }}
              >
                <Link
                  to={`/guide/${m.slug}`}
                  data-testid={`guide-card-${m.slug}`}
                  className="group flex h-full flex-col rounded-3xl bg-white p-7 border border-gray-100 shadow-sm transition-all duration-300 hover:-translate-y-1.5 hover:shadow-xl hover:shadow-brand/5"
                >
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-brand-light/30 text-brand transition-colors group-hover:bg-brand group-hover:text-white">
                    <Icon size={24} strokeWidth={2.5} />
                  </span>
                  <h3 className="mt-5 font-heading text-xl font-semibold text-brand-deep">{m.title}</h3>
                  <p className="mt-2 font-body text-ink leading-relaxed flex-1">{m.intro}</p>
                  <span className="mt-5 inline-flex items-center gap-1.5 font-body text-sm font-semibold text-brand group-hover:gap-2.5 transition-all">
                    Apri la guida <ArrowRight size={15} strokeWidth={2.5} />
                  </span>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
